<template>
	<div class="dashboard">
		<div class="notifications">
			<notifications group="default" classes="notification" />
			<notifications group="success" classes="notification" />
		</div>
		<loading
			:active="$store.state.progress"
			:can-cancel="true"
			:is-full-page="true"
			color="#fba628"
			loader="dots"
			:width=128
			:height=128
			background-color="#000000"
		></loading>
    <layoutHeader></layoutHeader>
		<div class="app-body">
			<layoutSidebar></layoutSidebar>
			<main class="main" v-if="$store.state.userModule.sync">
				<div class="breadcrumb-container">
					<ol class="breadcrumb" v-if="$breadcrumbs.length">
						<li class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs" :key="key" active>
							<router-link :to="linkProp(crumb)" disabled>{{ crumb.meta.breadcrumb }}</router-link>
						</li>
					</ol>
				</div>
				<div class="container-fluid main-container">
					<div class="funny-progress" v-if="$store.state.funny_progress === true">
						<iframe src="https://giphy.com/embed/ZXKZWB13D6gFO" width="480" height="289" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/bored-alice-in-wonderland-meh-ZXKZWB13D6gFO"></a></p>
					</div>
					<div id="ui-view">
						<router-view></router-view>
					</div>
				</div>
			</main>
		</div>
		<footer class="app-footer" style="display:none">
			<div>
			<a href="https://coreui.io/pro/">CoreUI Pro</a>
			<span>© 2018 creativeLabs.</span>
			</div>
			<div class="ml-auto">
			<span>Powered by</span>
			<a href="https://coreui.io/pro/">CoreUI Pro</a>
			</div>
		</footer>
		<ticket></ticket>
  </div>
</template>
<script>
// import vue-loading-overlay
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import layoutHeader from '@/views/layouts/header.vue'
import layoutSidebar from '@/views/layouts/sidebar.vue'
import layoutFooter from '@/views/layouts/footer.vue'
import Ticket from '@/components/event/Ticket.vue'
export default {
	name: 'App',
	components: {
		Loading,
		layoutHeader,
		layoutSidebar,
		layoutFooter,
		ticket: Ticket
	},
	data: function () {
		return {
			layout: null,
			headerIsShow: true,
			routeMatchedPath: ''
		}
	},
	beforeCreate: function () {
		this.layout = this.$route.meta.layout
	},
	methods: {
		linkProp: function (crumb) {
			// If it's a named route, we'll base the route
			// off of that instead
			if (crumb.name || (crumb.handler && crumb.handler.name)) {
				return {
					name: crumb.name || crumb.handler.name,
					params: this.$route.params
				}
			}

			return {
				path: (crumb.path === '')
					? '/'
					: crumb.path,
				params: this.$route.params
			}
		}
	}
}
</script>
<style>
.funny-progress {
	display: none;
	text-align: center;
}
.pace-running .funny-progress {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue